module.exports = __webpack_public_path__ + "static/media/coverForLomo.ae62028e.stl";